
import { defineComponent } from 'vue'
import SubscriptionMixin from '~/mixins/subscriptionMixin'
import OwnerBillingMixin from '~/mixins/ownerBillingMixin'

export default defineComponent({
  name: 'ResumePlan',
  mixins: [OwnerBillingMixin, SubscriptionMixin],
  data() {
    return {
      showConfirmDialog: false,
      message:
        'Confirm to void the plan cancellation request. This will give you full access to your existing plan.',
      updating: false
    }
  },
  methods: {
    showResumePlanModal() {
      this.showConfirmDialog = true
    },
    close() {
      this.showConfirmDialog = false
    },
    async resumePlan(close: () => void): Promise<void> {
      this.updating = true
      try {
        await this.revertSubscriptionCancellation({
          id: this.owner.id
        })
        this.$toast.success('Plan successfully resumed. Welcome back!')
      } catch (e) {
        this.$toast.danger('Something went wrong while resuming your plan.')
      } finally {
        this.$emit('refetch')
        await this.refetchData()
        this.updating = false
        if (close) {
          close()
        } else {
          this.showConfirmDialog = false
        }
      }
    },
    async refetchData(): Promise<void> {
      const { owner, provider } = this.$route.params
      await this.fetchBillingDetails({
        login: owner,
        provider,
        refetch: true
      })
    }
  }
})
